<div class="loading-overlay" [class.is-visible]="visible" [class.is-contained]="contained" [attr.aria-hidden]="!visible" [style.--lo-blur]="blurAmount">
    <div class="loading-overlay__content">
        <div class="loading-overlay__logo-wrap">
            <span class="loading-overlay__halo" aria-hidden="true"></span>
            <img class="loading-overlay__logo" [src]="logoSrc" alt="Fina" />
        </div>
        <div class="loading-overlay__dots" aria-hidden="true"><span></span><span></span><span></span></div>
        <div class="loading-overlay__message">{{ message }}</div>
    </div>
</div>

<!-- Click-shield invisible: cuando `contained=true`, bloquea clicks en sidebar/header
     mientras el overlay visual está acotado al módulo. Evita navegar a otra ruta con
     un fetch pendiente (memory leaks / componentes destruidos a mitad de carga). -->
<div *ngIf="visible && contained" class="loading-overlay__shield" aria-hidden="true"></div>
